import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FullSpinnerService {

  private message = new Subject<string|undefined>();

  constructor() { }

  public spinner = (message:string|undefined): void => {
    this.message.next(message===""?"Caricamento in corso ... ": message);
  }

  public getMessage = () =>
    this.message.asObservable();

}
